export default __webpack_public_path__ + "static/media/office2.68212b32.jpg";